/* Working days, because a schedule that counts weekends is wrong by a fifth.
 *
 * MS Project's default calendar is Monday to Friday, and both WAPA files use
 * it. Counting calendar days instead would put every computed date out by one
 * day per week, which over a two and a half year program is four months.
 *
 * Holidays are a list the contract can carry later. They are not here yet
 * because neither file declares any, and inventing a holiday calendar nobody
 * asked for would produce dates that disagree with the source plan for
 * reasons nobody could find.
 */

const DAY = 86400000;

export const toDate = (iso) => new Date(`${iso}T00:00:00Z`);
export const toIso = (date) => date.toISOString().slice(0, 10);

/* Saturday is 6, Sunday is 0. */
export const isWorkingDay = (iso) => {
  const day = toDate(iso).getUTCDay();
  return day !== 0 && day !== 6;
};

/* The next working day on or after the one given. A schedule that starts on a
   Saturday starts on the Monday, which is what every tool does and what
   anybody reading it assumes. */
export function snapForward(iso) {
  let d = toDate(iso);
  while (d.getUTCDay() === 0 || d.getUTCDay() === 6) d = new Date(d.getTime() + DAY);
  return toIso(d);
}

export function snapBack(iso) {
  let d = toDate(iso);
  while (d.getUTCDay() === 0 || d.getUTCDay() === 6) d = new Date(d.getTime() - DAY);
  return toIso(d);
}

/* Move n working days from a date. Zero snaps to a working day and stops,
   which matters: a milestone has no duration and still cannot land on a
   Sunday. Negative counts move backwards, which is what the backward pass
   needs. */
export function addWorkingDays(iso, n) {
  if (!iso) return null;
  let d = toDate(n >= 0 ? snapForward(iso) : snapBack(iso));
  let left = Math.abs(n);
  const step = n >= 0 ? DAY : -DAY;
  while (left > 0) {
    d = new Date(d.getTime() + step);
    const day = d.getUTCDay();
    if (day !== 0 && day !== 6) left -= 1;
  }
  return toIso(d);
}

/* Duration in working days, counted inclusively: a task that starts and
   finishes on the same Tuesday is one day long, not zero. That is the
   convention every scheduling tool uses and the one a person means when they
   say "it takes a day". */
export function workingDaysBetween(startIso, finishIso) {
  if (!startIso || !finishIso) return null;
  if (finishIso < startIso) return 0;
  let d = toDate(startIso);
  const end = toDate(finishIso);
  let n = 0;
  while (d <= end) {
    const day = d.getUTCDay();
    if (day !== 0 && day !== 6) n += 1;
    d = new Date(d.getTime() + DAY);
  }
  return n;
}
